// extracted by mini-css-extract-plugin
export default {"main":"styles_main__nxdNH","select-block-container":"styles_select-block-container__-wrI4","text-area-container":"styles_text-area-container__G-jeG"};